import { useContext, useState } from "react";
import classes from "./SelectLanes.module.css";
import { Row, Column, TwoColumnLayout } from "../../../Shared/FlexDiv/FlexDiv";
import { Urls } from "../../../../Urls";
import Unauthorized from "../../../Unauthorized";
import {
  Activity,
  currentRequestTimeStamp,
  isMobile,
} from "../../../../Constants";
import gif from "../../../../Content/images/finalgif.gif";
import PremiumPopup from "../../../PremiumPopup/PremiumPopup";
import mixpanel from "mixpanel-browser";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";

const SelectLanes = ({
  allowedLanes,
  maxlanes,
  currentLaneList = [],
  updateCurrentLaneList,
  getSessionID,
}) => {
  const [currentChecked, setCurrentChecked] = useState([]);
  const { userDetails } = useContext(UserApiContext);

  const deleteItem = (Lane) => {
    Activity([
      {
        screen: "My Freight Benchmark",
        module: "My Freight Benchmark ",
        user_activity: `Deleted ${Lane.laneKey}`,
        timestamp: currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name
        , companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : ""
      },
    ]);
    mixpanel.track(`User has deleted lane from benchmark`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "landing_page",
      ActivityLog: "userClickedDeleteLaneButton",
      Data: `${Lane.laneKey}`,
      Definition: `User has deleted lane from benchmark`,
      ActivityType: "event_view",
      UserName: userDetails?.user_name,
      UserEmail: userDetails?.email,
      CompanyName: userDetails.company_name
        ? userDetails.company_name
        : userDetails.email
          ? userDetails.email.split("@")[1].split(".")[0]
          : ""
    });
    setCurrentChecked(currentChecked.filter((item) => item !== Lane.laneKey));

    updateCurrentLaneList(
      currentLaneList.filter((item) => {
        return Lane.laneKey.trim() !== item.laneKey.trim();
      })
    );
  };

  const Actions = () => {
    return (
      <Row className={`${classes["my-row-flex"]}`}>
        {/* {currentLaneList && currentLaneList.length>0? */}
        <button
          className={`btn btn-sm btn-success ${classes["s-glb"]}`}
          disabled={
            currentLaneList && currentLaneList.length > 0 ? false : true
          }
          onClick={(e) => getSessionID()}
        >
          Get LoRRI Benchmark
        </button>
      </Row>
    );
  };

  const MobileBody = () => {
    return (
      <Column
        className={`${classes["fixed-flex-height"]} ${currentLaneList && currentLaneList.length === 0
          ? classes["center-align"]
          : ""
          }`}
      >
        {currentLaneList && currentLaneList.length > 0 ? (
          currentLaneList.map((item, index) => {
            return (
              <Column className={classes["BenchMark-Table-Body-Row-Mobile"]}>
                <Row>
                  <Column className={classes["left-column-98"]}>
                    <TwoColumnLayout
                      leftColumn={<label>Origin</label>}
                      rightColumn={
                        item.origin && item.origin.location_name
                          ? item.origin.location_name
                          : ""
                      }
                    />

                    <TwoColumnLayout
                      leftColumn={<label>Destination</label>}
                      rightColumn={
                        item.destination && item.destination.location_name
                          ? item.destination.location_name
                          : ""
                      }
                    />
                    <TwoColumnLayout
                      leftColumn={<label>Truck Type</label>}
                      rightColumn={
                        item.truck_type ? <span>{item.truck_type}</span> : ""
                      }
                    />
                  </Column>
                  <Column className={classes["right-column-2"]}>
                    <button
                      style={{ marginTop: "-9%" }}
                      className={`btn btn-primary btn-sm ${classes["Close-Button"]}`}
                      onClick={(e) => deleteItem(item)}
                    >
                      <i
                        style={{ color: "#393185", fontSize: "16px" }}
                        className={`fa fa-trash ${classes["Custom-Close"]}`}
                      />
                    </button>
                  </Column>
                </Row>
              </Column>
            );
          })
        ) : (
          <div style={{ textAlign: "center" }}>
            {/* <img src={road} height="140px"/> */}
            {/* <img src={giff} height="390px" width="390px"/> */}
            <img alt="gif" src={gif} height="350px" width="350px" />
          </div>
        )}
      </Column>
    );
  };

  const Table = () => {
    return (
      <div className={classes["t-div"]}>
        <table className={classes["table-s"]}>
          <thead
            style={{
              textAlign: "center",
              boder: "none",
              borderTop: "1px solid black",
            }}
          >
            <tr>
              <th
                style={{
                  border: "none",
                  borderBottom: "1px solid grey",
                  width: "7%",
                  textAlign: "center",
                }}
              >
                Sr. No.
              </th>
              <th
                style={{
                  border: "none",
                  borderBottom: "1px solid grey",
                  width: "30%",
                  textAlign: "center",
                }}
              >
                Origin
              </th>
              <th
                style={{
                  border: "none",
                  borderBottom: "1px solid grey",
                  width: "30%",
                  textAlign: "center",
                }}
              >
                Destination
              </th>
              <th
                style={{
                  border: "none",
                  borderBottom: "1px solid grey",
                  width: "25%",
                  textAlign: "center",
                }}
              >
                Truck Type
              </th>
              <th
                style={{
                  border: "none",
                  borderBottom: "1px solid grey",
                  width: "10%",
                  textAlign: "center",
                }}
              ></th>
            </tr>
          </thead>
          <tbody style={{ height: "35vh" }}>
            {currentLaneList && currentLaneList.length > 0
              ? currentLaneList.map((item, index) => {
                return (
                  <tr key={index} style={{ border: "none" }}>
                    <td
                      style={{
                        border: "none",
                        width: "7%",
                        borderBottom: "1px solid black",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        border: "none",
                        width: "30%",
                        borderBottom: "1px solid black",
                      }}
                    >
                      {item.origin_name ? item.origin_name : ""}
                    </td>
                    <td
                      style={{
                        border: "none",
                        width: "30%",
                        borderBottom: "1px solid black",
                      }}
                    >
                      {item.destination_name ? item.destination_name : ""}
                    </td>
                    <td
                      style={{
                        border: "none",
                        width: "25%",
                        borderBottom: "1px solid black",
                      }}
                    >
                      {item.truck_type ? <span>{item.truck_type}</span> : ""}
                    </td>
                    <td
                      style={{
                        border: "none",
                        width: "10%",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <button
                        style={{ marginTop: "-9%" }}
                        className={`btn btn-primary btn-sm ${classes["Close-Button"]}`}
                        onClick={(e) => deleteItem(item)}
                      >
                        <i
                          style={{ color: "#393185", fontSize: "16px" }}
                          className={`fa fa-trash ${classes["Custom-Close"]}`}
                        />
                      </button>
                    </td>
                  </tr>
                );
              })
              : null}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      {!isMobile() ? (
        <>
          <div
            className="row"
            style={{
              marginLeft: "3%",
              width: "100%",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <span>
              <h5 style={{ fontSize: "13px" }} className="row">
                <div className={`${classes["new-card"]}`}>
                  <span>Step1: Add your lanes</span>
                </div>
                {"    ---   "}
                <div className={`${classes["new-card"]}`}>
                  <span>Step 2: Get LoRRI Benchmark</span>
                </div>
                {"    ---   "}
                <div className={`${classes["new-card"]}`}>
                  <span>Step 3: View Transporters</span>
                </div>
                {"   ---   "}
                <div className={`${classes["new-card"]}`}>
                  <span>Step 4: Get spot rates</span>
                </div>
              </h5>
            </span>
          </div>
          {currentLaneList && currentLaneList.length ? (
            <>
              <Table />
              <Actions />
            </>
          ) : (
            <div>
              <div style={{ textAlign: "center", height: "50%" }}>
                <img alt="gif" src={gif} height="450" width="690" />
              </div>
              {/* <PremiumPopup /> */}
            </div>
          )}
        </>
      ) : (
        <>
          <MobileBody />
          <Actions />
        </>
      )}
    </>
  );
};

export default SelectLanes;
